import { useEffect, useRef, useContext, useState } from "react"
import { GpraContext } from "../../../context/gpraContext"
import { endpoints } from "../../../config/gpraApiEndpoints"
import { showMessage } from "../utils/utils"
import ServicesReceived3 from "../Forms/K/ServicesReceived/ServicesReceived3"
import { LoaderMedium } from "../../../components/Loaders"
import { INTERVIEW_SECTIONS } from "../types/interviewTypes"
import { UserContext } from "../../../context/userContext"

const ServicesReceived3Container = ({
  showToolBar,
  disabled,
  interview_id,
}) => {
  const { interview, handleSubmitGet, handleLoadPrev, loadCollection } =
    useContext(GpraContext)
  const userCtx = useContext(UserContext)
  const [isGettingServicesReceived, setIsGettingServicesReceived] =
    useState(true)

  const toast = useRef()

  useEffect(() => {
    setIsGettingServicesReceived(true)
    if (
      interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id ||
      interview_id
    ) {
      handleSubmitGet(endpoints.GET_SERVICESRECEIVED_DATA, {
        gpra_interview_id: interview_id
          ? interview_id
          : interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
          organization_id: userCtx.session.user.organization_id,
        section: INTERVIEW_SECTIONS.SERVICES_RECEIVED_3,
      })
        .then((response) => {
          loadCollection(
            setValues(response.data),
            INTERVIEW_SECTIONS.SERVICES_RECEIVED_3
          )
          handleLoadPrev(false)
          setIsGettingServicesReceived(false)
        })
        .catch((error) => {
          showMessage(false, error, toast)
          handleLoadPrev(false)
          setIsGettingServicesReceived(false)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const setValues = (data) => {
    return {
      gpra_k_cm_1: data?.form?.gpraKCm1 ?? 0,
      gpra_k_cm_2: data?.form?.gpraKCm2 ?? 0,
      gpra_k_cm_3a: data?.form?.gpraKCm3a ?? 0,
      gpra_k_cm_3b: data?.form?.gpraKCm3b ?? 0,
      gpra_k_cm_4: data?.form?.gpraKCm4 ?? 0,
      gpra_k_cm_5: data?.form?.gpraKCm5 ?? 0,
      gpra_k_cm_6a: data?.form?.gpraKCm6a ?? 0,
      gpra_k_cm_6b: data?.form?.gpraKCm6b ?? 0,
      gpra_k_cm_6c: data?.form?.gpraKCm6c ?? 0,
      gpra_k_cm_7: data?.form?.gpraKCm7 ?? 0,
      gpra_k_cm_8: data?.form?.gpraKCm8 ?? 0,
      gpra_k_cm_9: data?.form?.gpraKCm9 ?? 0,
      gpra_k_cm_10: data?.form?.gpraKCm10 ?? 0,
      gpra_k_cm_10a: data?.form?.gpraKCm10a ?? "",
      gpra_k_ms_1: data?.form?.gpraKMs1 ?? 0,
      gpra_k_ms_2: data?.form?.gpraKMs2 ?? 0,
      gpra_k_ms_3: data?.form?.gpraKMs3 ?? 0,
      gpra_k_ms_4: data?.form?.gpraKMs4 ?? 0,
      gpra_k_ms_5: data?.form?.gpraKMs5 ?? 0,
      gpra_k_ms_6: data?.form?.gpraKMs6 ?? 0,
      gpra_k_ms_7: data?.form?.gpraKMs7 ?? 0,
      gpra_k_ms_8: data?.form?.gpraKMs8 ?? 0,
      gpra_k_ms_8a: data?.form?.gpraKMs8a ?? "",
      gpra_k_acs_1: data?.form?.gpraKAcs1 ?? 0,
      gpra_k_acs_2: data?.form?.gpraKAcs2 ?? 0,
      gpra_k_acs_3: data?.form?.gpraKAcs3 ?? 0,
      gpra_k_acs_4: data?.form?.gpraKAcs4 ?? 0,
      gpra_k_acs_5: data?.form?.gpraKAcs5 ?? 0,
      gpra_k_acs_6: data?.form?.gpraKAcs6 ?? 0,
      gpra_k_acs_6a: data?.form?.gpraKAcs6a ?? "",
      gpra_k_id: data?.form?.gpraKId ?? 0,
      additional: data?.additional,
    }
  }
  if (isGettingServicesReceived) {
    return <LoaderMedium></LoaderMedium>
  }
  return (
    <>
      {!isGettingServicesReceived && (
        <ServicesReceived3 showToolBar={showToolBar} disabled={disabled} />
      )}
    </>
  )
}
export default ServicesReceived3Container
